/**
 * subject-context-type.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * NOTE: These shouldn't really be hard-coded, but in the short term it's
 * useful to be able to distinguish them and add a little type safety. At some
 * point the server will likely start communicating information about the
 * available types, and we can do away with this though. (TODO)
 */
export type SubjectContextType =
    "healthcare benefits" | "issue report" | "client test" | "path chooser";
    // | "«amorphous»";

export class KnownSubjectContextTypes
{
    public static Healthcare : SubjectContextType = "healthcare benefits";
    public static IssueReport : SubjectContextType = "issue report";
    public static ClientTest : SubjectContextType = "client test";
    public static PathChooser : SubjectContextType = "path chooser";
    // public static Amorphous : SubjectContextType = "«amorphous»";
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/subjects/subject-context-type.ts